
import {DateTimeWithZone} from '../common/date-time-with-zone.class';
import {ICompanyOptInAcceptanceSummary} from '../message-models/company-opt-in-acceptance-summary.interface';
import {consts} from '../common/modals/consts';
import {DecisionRequirement} from '../message-models/decision-requirement.enum';

export class CompanyOptInAcceptanceSummary implements ICompanyOptInAcceptanceSummary{
  companyId: string;
  optInEntryId: string;
  optInUrl: string;
  optInDescription: string;
  decisionOn: DateTimeWithZone;
  decisionBy: string;
  decisionLabel: string;
  decisionIpAddress: string;
  decisionRequirement: DecisionRequirement;
  decision: boolean | null;
  defaultOptInState: boolean;
  visitedOn: DateTimeWithZone;
  visitedBy: string;
  visitedIpAddress: string;
  isActive: boolean;
  mustVisit: boolean;
  openOnSamePage: boolean;
  userFocused: boolean;
  visited?: boolean;
  errorText: string;
  showMustVisit: boolean;
  showError: boolean;
  decisionFinalised: boolean;


  constructor(iCompanyOptInAcceptanceSummary?: ICompanyOptInAcceptanceSummary) {
    this.companyId = iCompanyOptInAcceptanceSummary?.companyId || consts.emptyGuid;
    this.optInEntryId = iCompanyOptInAcceptanceSummary?.optInEntryId || consts.emptyGuid;
    this.optInUrl = iCompanyOptInAcceptanceSummary?.optInUrl || '';
    this.optInDescription = iCompanyOptInAcceptanceSummary?.optInDescription || '';
    this.decisionOn = new DateTimeWithZone(iCompanyOptInAcceptanceSummary?.decisionOn);
    this.decisionBy = iCompanyOptInAcceptanceSummary?.decisionBy || '';
    this.decisionIpAddress = iCompanyOptInAcceptanceSummary?.decisionIpAddress || '';
    this.decisionRequirement = iCompanyOptInAcceptanceSummary?.decisionRequirement ?? DecisionRequirement.MandatoryYes;
    this.decision = iCompanyOptInAcceptanceSummary?.decision ?? null;
    this.defaultOptInState = iCompanyOptInAcceptanceSummary?.defaultOptInState || false;
    this.visitedOn = new DateTimeWithZone(iCompanyOptInAcceptanceSummary?.visitedOn);
    this.visitedBy = iCompanyOptInAcceptanceSummary?.visitedBy || '';
    this.visitedIpAddress = iCompanyOptInAcceptanceSummary?.visitedIpAddress || '';
    this.isActive = iCompanyOptInAcceptanceSummary?.isActive || false;
    this.mustVisit = iCompanyOptInAcceptanceSummary?.mustVisit || false;
    this.openOnSamePage = iCompanyOptInAcceptanceSummary?.openOnSamePage || false;
    this.userFocused = iCompanyOptInAcceptanceSummary?.userFocused || false;
    this.decisionLabel = iCompanyOptInAcceptanceSummary?.decisionLabel || '';
    this.visited = iCompanyOptInAcceptanceSummary?.visited;
    this.errorText = iCompanyOptInAcceptanceSummary?.errorText || 'Please make your decision before continuing';
  }

  getDecisionRequirementClass():string {
    switch (this.decisionRequirement) {
      case DecisionRequirement.None:
        return '';
      case DecisionRequirement.MandatoryYes:
        return 'optin-mandatory';
      case DecisionRequirement.MandatoryNo:
        return 'optin-mandatory';
      case DecisionRequirement.OptionalYesNo:
        return 'optin-optional';
    }
    return '';
  }
  getVisitedClass():string {
    if(!!this.visitedOn.dateTime ){
      return 'optin-visited';
    }else if(this.visitedOn.dateTime === '' || this.visitedOn.dateTime === null){
      return 'optin-not-visited';
    }
  }
  getIcon():string {
    if(this.optInUrl === ''){
      return 'info-circle';
    }else{
      if(this.openOnSamePage) {
        return 'link';
      }else{
        return 'external-link-square';
      }
    }
  }
  get isUrlVisited(): boolean {
    return !!this.visitedOn.dateTime;
  }

  get decisionRequired(): boolean {
    return this.decisionRequirement !== DecisionRequirement.None;
  }

}


